import React from 'react';

export default function PageContent ({ children }) {
    return (
        <div className="mtt-template-content__content-wrapper mtt-template-content__content-wrapper--ads">
            <div className="mtt-template-content__content-top styled-text add-padding">
                { children }
            </div>
        </div>
    )
}
